import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapCollection } from './normalize'

export type MonitoringWorkflow = {
  id: number
  name: string
  description: string
  siteRequired: boolean
}

// v1 on purpose: the v2 ref-data DTO drops siteRequired, which the event forms filter on.
export default async function getMonitoringWorkflows({
  signal,
}: {
  signal?: AbortSignal
} = {}): Promise<MonitoringWorkflow[]> {
  const response = await apiClient.get(endpoints.workflows, { signal })
  return unwrapCollection<MonitoringWorkflow>(response)
}
